import BaseNPCView from "./BaseNPCView";


export default class BoatView extends BaseNPCView {

    constructor(target) {
        super(target);
    }


    
    stopAnimations() {
        createjs.Tween.removeTweens(this._target);
    }

    wiggle() {
        const rotation = 2;
        this._target.rotation = -rotation;
        const props = { loop: 3, bounce: true, onComplete: () => {
            this._target.rotation = 0; 
        } };
        createjs.Tween.get(this._target, props).to({ rotation: rotation }, 60);
    }
};
